module.exports = __webpack_public_path__ + "img/productHSE_5.d22b0c3e.png";